import initState from './initState';

export default {
  setReportId(state, data) {
    state.report[data.key] = data.value;
  },
  beforedataform(state, data) {
    state.beforedataform = data;
  },
  formId(state, data) {
    state.formId = data;
  },
  selectmenu(state, data) {
    state.selectmenu = data;
  },
  updateUser(state, data){
    state.islogin[data.key] = data.value
    console.log(data)
  },
  updateUserToken(state, data){
    state.islogin.token = data.value
  },
  profilemenumargin(state, data) {
    state.profilemenumargin = data;
  },
  datasignup(state, data) {
    state.datasignup = data;
  },
  rememberlogin(state, data) {
    state.rememberlogin = data;
  },
  idlogin(state, data) {
    state.idlogin = data;
  },
  senddatamentor(state, data) {
    state.senddatamentor = data;
  },
  setPercent(state,data){
    state.setPercent = data
  },
  clearlogin(state, data) {
    const initial = initState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
  islogin(state, data) {
    state.islogin = data;
  },
  viewprofile(state, data) {
    state.viewprofile = data;
  },
  mentoridprofile(state, data) {
    state.mentoridprofile = data;
  },
  stepbooking(state, data) {
    state.stepbooking = data;
  },
  timebooking(state, data) {
    state.timebooking = data;
  },
  
  datebooking(state, data) {
    state.datebooking = data;
  },
  startdatebooking(state, data) {
    state.startdatebooking = data;
  },
  clearbooking(state,data){
    if(data == true){
      state.timebooking = ''
      state.datebooking = ''
      state.startdatebooking = ''
      state.mentoridprofile = ''
    }
  },
  changenamesurnamepic(state, data) {
    state.islogin.name = data.name
    state.islogin.surname = data.surname
    state.islogin.profilePic = data.profilePic
  },
  setCompanyInvest(state, data){
    state.companyInvest = data
  },
  setInvestMath(state, data){
    state.investMath = data
  },
  setShowTicket(state, data){
    state.showTicket = data
  }
};
